import styled from "styled-components";

const Label = styled.label`
  color: ${({ color }) => color || "#aba5b6"};
  font-weight: 200;
  font-size: "1rem";
  & [htmlFor] {
    cursor: pointer;
  }
`;

export default Label;
